const topics = [
  { label: '日剧推荐', count: '2.3万讨论' },
  { label: '美剧追更', count: '1.8万讨论' },
  { label: '国产剧安利', count: '3.1万讨论' },
  { label: '华语电影', count: '1.5万讨论' },
  { label: '欧美大片', count: '2.7万讨论' },
  { label: '悬疑烧脑', count: '1.2万讨论' },
  { label: '治愈系', count: '9800讨论' },
  { label: '科幻迷', count: '1.6万讨论' },
  { label: '古装权谋', count: '2.1万讨论' },
  { label: '高甜恋爱', count: '1.9万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门话题
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              大家都在讨论什么？加入话题聊聊你的观剧感受
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <a
                key={topic.label}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/40 transition-all duration-200 cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                  #{topic.label}
                </span>
                <span className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}